import React, { useState, useEffect } from "react";
import axiosInstance from '../../../axiosInstance.js';
import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import "./Panel.css";
import {SideBar} from "../SideBar/SideBar.js";
// import { PaperClipIcon } from '@heroicons/react/20/solid'
import { Navbar } from '../Navbar/Navbar.js';
import { Button, Checkbox, Label, TextInput } from "flowbite-react";
// import Link from "next/link";

const AboutPanel = () => {
  const [aboutContent, setAboutContent] = useState(null);
  const [formData, setFormData] = useState({
    subTitle: "",
    title: "",
    description: "",
    services: "",
    companyName: "",
    founders: "",
    img1: null,
    img2: null,
    signImage: null,
  });
  const [editing, setEditing] = useState(false);

  useEffect(() => {
    fetchAboutContent();
  }, []);

  const fetchAboutContent = async () => {
    try {
      const response = await axiosInstance.get("/about/content");
      setAboutContent(response.data);
    } catch (error) {
      console.error("Error fetching About content:", error);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.files[0] });
  };

  const handleEdit = () => {
    if (aboutContent) {
      const { subTitle, title, description, services, companyName, founders } =
        aboutContent;
      setFormData({
        subTitle,
        title,
        description,
        services: services.join("\n"), 
        companyName,
        founders,
        img1: null,
        img2: null,
        signImage: null,
      });
      setEditing(true);
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      const formDataToSend = new FormData();
      formDataToSend.append("subTitle", formData.subTitle);
      formDataToSend.append("title", formData.title);
      formDataToSend.append("description", formData.description);
      formDataToSend.append(
        "services",
        JSON.stringify(formData.services.split("\n"))
      );
      formDataToSend.append("companyName", formData.companyName);
      formDataToSend.append("founders", formData.founders);
      if (formData.img1) {
        formDataToSend.append("img1", formData.img1);
      }
      if (formData.img2) {
        formDataToSend.append("img2", formData.img2);
      }
      if (formData.signImage) {
        formDataToSend.append("signImage", formData.signImage);
      }

      const response = await axiosInstance.put(
        `/about/${aboutContent._id}`,
        formDataToSend,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status === 200) {
        fetchAboutContent();
        setFormData({
          subTitle: "",
          title: "",
          description: "",
          services: "",
          companyName: "",
          founders: "",
          img1: null,
          img2: null,
          signImage: null,
        });
        setEditing(false);
      } else {
        console.error("Update failed:", response.statusText);
      }
    } catch (error) {
      console.error("Update error:", error);
    }
  };

  return (
    <><><div className="flex">
        <SideBar/>
      <div className="flex-1 h-screen p-6 overflow-auto bg-gray-100">
        <div className="max-w-3xl mx-auto panel-container">
          <div className="panel-form bg-white p-8 rounded-lg shadow-xl">
          <h2 className="admin-nav-heading text-2xl font-semibold mb-6 text-gray-800">About Panel</h2>
          <form className="space-y-6" onSubmit={handleUpdate}>
            <div>
              <label htmlFor="img1">Image 1:</label>
              <input
                type="file"
                name="img1"
                onChange={handleFileChange}
                accept="image/*" 
                className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
            </div>
            <div>
              <label htmlFor="img2">Image 2:</label>
              <input
                type="file"
                name="img2"
                onChange={handleFileChange}
                accept="image/*" 
                className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
            </div>
            <div>
              <label htmlFor="signImage">Sign Image:</label>
              <input
                type="file"
                name="signImage"
                onChange={handleFileChange}
                accept="image/*" 
                className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
            </div>
            <div>
              <label htmlFor="subTitle">Sub Title:</label>
              <input
                type="text"
                name="subTitle"
                value={formData.subTitle}
                onChange={handleChange}
                placeholder="Sub Title"
                className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                required />
            </div>
            <div>
              <label htmlFor="title">Title:</label>
              <input
                type="text"
                name="title"
                value={formData.title}
                onChange={handleChange}
                placeholder="Title"
                className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"

                required />
            </div>
            <div>
              <label htmlFor="description">Description:</label>
              <input
                type="text"
                name="description"
                value={formData.description}
                onChange={handleChange}
                placeholder="Description"
                className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                required />
            </div>
            <div>
              <label htmlFor="services">Services:</label>
              <textarea
                className="serv"
                name="services"
                value={formData.services}
                onChange={handleChange}
                placeholder="Services (one per line)"
                className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                 required />
            </div>
            <div>
              <label htmlFor="companyName">Company Name:</label>
              <input
                type="text"
                name="companyName"
                value={formData.companyName}
                onChange={handleChange}
                placeholder="Company Name"
                className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                required />
            </div>
            <div>
              <label htmlFor="founders">Founders:</label>
              <input
                type="text"
                name="founders"
                value={formData.founders}
                onChange={handleChange}
                placeholder="Founders"
                className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"

                required />
            </div>
            <button type="submit" className="px-6 py-3 bg-blue-500 text-white font-semibold rounded-lg hover:bg-blue-600 transition-colors duration-300">Update</button>
            {editing && (
              <button type="button" className="px-6 py-3 bg-blue-500 text-white font-semibold rounded-lg hover:bg-blue-600 transition-colors duration-300" onClick={() => setEditing(false)}>
                Cancel
              </button>
            )}
          </form>
          {aboutContent && !editing && (
            <div>
              <h3>{aboutContent.title}</h3>
              <p>{aboutContent.subTitle}</p>
              <p>{aboutContent.description}</p>
              <p>Services: {aboutContent.services.join(", ")}</p>
              <p>Company Name: {aboutContent.companyName}</p>
              <p>Founders: {aboutContent.founders}</p>
              <div className="flex justify-end">
              <button className="px-6 py-3 bg-blue-500 text-white font-semibold rounded-lg hover:bg-blue-600 transition-colors duration-300" onClick={handleEdit}>Edit</button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
    </div></>
  


    {/* <form className="flex max-w-md flex-col gap-4">
      <div>
        <div className="mb-2 block">
          <Label htmlFor="email2" value="Your email" />
        </div>
        <TextInput id="email2" type="email" placeholder="name@flowbite.com" required shadow />
      </div>
      <div>
        <div className="mb-2 block">
          <Label htmlFor="password2" value="Your password" />
        </div>
        <TextInput id="password2" type="password" required shadow />
      </div>
      <div>
        <div className="mb-2 block">
          <Label htmlFor="repeat-password" value="Repeat password" />
        </div>
        <TextInput id="repeat-password" type="password" required shadow />
      </div>
      <div className="flex items-center gap-2">
        <Checkbox id="agree" />
        <Label htmlFor="agree" className="flex">
          I agree with the&nbsp;
          <Link href="#" className="text-cyan-600 hover:underline dark:text-cyan-500">
            terms and conditions
          </Link>
        </Label>
      </div>
      <Button type="submit">Register new account</Button>
    </form> */}


      </>
  )
}


export default AboutPanel;
